import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { titleTemplate } from 'utils/seoUtils';
import { StandardPage } from "../../Common/pages/StandardPage";
import { RightColumn } from "../../Common/pages/RightColumn";
import MyStablePageContainer from "./MyStablePageContainer";
import HorseRacingMostFollowed from "./HorseRacingMostFollowed";

export default class MyStablePage extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    MyStablePageContainer: PropTypes.object.isRequired,
  };

  render() {
    const { location, router } = this.props;

    return (
      <StandardPage sport="racing" title="My Stable" helmetProps={{titleTemplate: titleTemplate.plain}}>
        <div className="main-layout-left-column">
          <div className="main-layout-block last-desktop">
            <MyStablePageContainer location={location} router={router} >
              {this.props.MyStablePageContainer.props.children}
            </MyStablePageContainer>
          </div>
          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <HorseRacingMostFollowed location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingMostFollowed", "horseRacingNextRaceOffAll", "bottomMpu", "ocWidget"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/MyStablePage.js